module.exports = __webpack_public_path__ + "assets/icon-person-search-component.99fb78e8.svg";